<template>
  <v-container fluid>
    <h2>Assessment</h2>

    <v-card-title>
      <div class="my-2">
        <v-btn v-if="loggedRoleId == 2" @click="newItem()" color="primary" style="margin:10px">CREATE</v-btn>        
        <v-btn v-if="loggedRoleId == 2" color="primary" @click="downloadCsv()">EXPORT</v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="SEARCH"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="assessmentTypes"
      :search="search"
      item-key="name"
      class="elevation-1"
    >
      <template v-slot:[`item.updatedOn`]="{ item }">
        <span>{{moment(item.updatedOn).format('MM-DD-YYYY') }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="editRowClick(item)">mdi-pencil</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              style="margin-left: 20px;"
              v-bind="attrs"
              v-on="on"
              @click="goToAction(item)"
            >mdi-arrow-right-bold</v-icon>
          </template>
          <span>Go to</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Assessment</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="form">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      label="Assessment Name"
                      :rules="requiredField"
                      v-model="dialogItem.name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-switch v-model="dialogItem.active" class="ma-2" label="Active?"></v-switch>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <!-- <small>*indicates required field</small> -->
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
            <div v-if="dialogItem.assessmentTypeId > 0">
              <v-btn color="blue darken-1" text @click="updateItem()">update</v-btn>
            </div>
            <div v-else>
              <v-btn color="blue darken-1" text @click="saveItem()">Save</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-debugger */
export default {
  data: () => ({
    search: "",
    assessmentTypes: [],
    headers: [
      {
        text: "ID",
        align: "start",
        value: "assessmentTypeId",
      },
      { text: "ASSESSMENT NAME", value: "name" },
      { text: "ACTIVE", value: "active" },
      { text: "UPDATED BY", value: "updatedBy" },
      { text: "UPDATED ON", value: "updatedOn" },
      { text: "ACTIONS", value: "actions" },
    ],
    dialog: false,
    dialogItem: {
      assessmentTypeId: "-1",
      name: "",
      active: true,
      updatedBy: "",
      updatedOn: "",
    },
    tempItem: {},
    requiredField: [
      (v) => !!v || "This field is required",
      (v) => v.length >= 3 || "Minimum length is 3 characters",
    ],
  }),
  methods: {
    editRowClick(item) {
      this.tempItem = item;
      this.dialogItem = JSON.parse(JSON.stringify(item));
      this.dialog = true;
      //console.log(item);
    },
    newItem() {
      this.dialogItem = {
        assessmentTypeId: "-1",
        name: "",
        active: true,
        updatedBy: "",
        updatedOn: "",
      };
      this.dialog = true;
      console.log(this.dialogItem);
      console.log("you click new Item");
    },
    saveItem() {
      if (this.$refs.form.validate()) {
        debugger;
        const baseURI = this.$store.getters.getBaseUrl + "assessmentType";
        this.$http
          .post(baseURI, this.dialogItem)
          .then((result) => {
            console.log(result.data);
            debugger;
            this.assessmentTypes.push(result.data);
            this.dialog = false;
          })
          .catch(function (error) {
            console.log("error " + error);
            alert("error" + error.response.data);
          });
        //console.log("you click save item");
      }
    },
    updateItem() {
      //OID20005
      if (this.$refs.form.validate()) {
        console.log(this.dialogItem);
        //debugger

        this.tempItem.assessmentTypeId = this.dialogItem.assessmentTypeId;
        this.tempItem.name = this.dialogItem.name;
        this.tempItem.active = this.dialogItem.active;
        this.tempItem.updatedBy = this.$store.getters.getUsername;
        this.tempItem.updatedOn = this.moment().format("MM-DD-YYYY");

        this.$http
          .post(
            this.$store.getters.getBaseUrl + "assessmentType",
            this.dialogItem
          )
          .then(() => {
            //debugger
            this.dialog = false;
          })
          .catch(function (error) {
            console.log("error " + error);
            alert("error" + error.response.data);
          });
      }
    },
    goToAction(item){
      
      //this.$store.setSelectedAssessmentType = item
       this.$store.commit("setSelectedAssessmentType", item);
      this.$router.push({
        path: "assessment",
        query: { assessmentTypeId : item.assessmentTypeId },
      });
    },
  downloadCsv() {
      //OID40001
      
      this.$http
        .request({
          url:
            this.$store.getters.getBaseUrl + "assessmentType/?isReport=true",
          method: "GET",
          responseType: "blob",
        })
        .then((result) => {
          const url = window.URL.createObjectURL(new Blob([result.data]));          
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'assessmentType.csv'); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    }
  
  },
  created(){
    //debugger
  },
  mounted() {
    //console.log("run mounted");
    //OID20005
    this.$http
      .get(this.$store.getters.getBaseUrl + "assessmentType")
      .then((result) => {
        this.assessmentTypes = result.data;
      })
      .catch(function (error) {
        console.log("error " + error);
        alert("error" + error.response.data);
      });
  },
  computed:{
     loggedRoleId() {
      return this.$store.getters.getRoleId;
    }
  }
};
</script>